import React from 'react';

import { twMerge } from 'tailwind-merge';

import { ISize } from '@/types/cms';
import type { FeatureHeaderProperties } from './index';
import { parseJson } from '@/utils/parseJson';
interface TitleProps {
  className?: string;
  properties: FeatureHeaderProperties;
}

const FONT_SIZE_CLASS_MAP = {
  [ISize.small]: 'enki-heading-xl',
  [ISize.middle]: 'enki-heading-2xl',
  [ISize.large]: 'enki-heading-3xl'
} as const;

const Title: React.FC<TitleProps> = ({ className, properties }) => {
  const { title, title_style } = properties;
  const titleStyle = parseJson(title_style) ?? {};

  if (!title) return <></>;
  return (
    <div
      data-role="title"
      data-testid="wid-featured-header-title"
      className={twMerge(
        FONT_SIZE_CLASS_MAP[(titleStyle.font_size as ISize) ?? ISize.middle],
        'text-surface-100-fg-default break-words',
        className
      )}
      style={{
        color: titleStyle.color
      }}>
      {title}
    </div>
  );
};

export default Title;
